import { render, staticRenderFns } from "./xeChartPie.vue?vue&type=template&id=747f34b8"
import script from "./xeChartPie.vue?vue&type=script&lang=js"
export * from "./xeChartPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports